import React, { useContext } from 'react'

import { compose } from 'recompose'

import { MOC_ONBOARDING_FLOW } from 'app-constants'
import Nav from 'components/Nav'
import { FunnelName, PageName } from 'generated/types'
import { getFlow } from 'utils/FlowProvider/utils'
import { FunnelContext } from 'utils/FunnelContext'
import { WithOptimizelyProps, withOptimizely } from 'utils/Optimizely'
import { dynamicPricingScreen } from 'utils/Optimizely/features'

import DeprecatedPricingInterstitial from './deprecated/DeprecatedPricingInterstitial'
import { DynamicPricingInterstitial } from './DynamicPricingInterstitial'
import MOCTierPricing from './MOC'

type Props = WithOptimizelyProps

const enhance = compose<Props, {}>(withOptimizely)

const PricingInterstitial: React.FC<Props> = ({ isFeatureEnabled }) => {
  const { isBackEnabled, isDynamicFunnelEnabled, metadata } = useContext(FunnelContext)

  if (
    (isDynamicFunnelEnabled && metadata.name === FunnelName.MightyOakCard) ||
    getFlow() === MOC_ONBOARDING_FLOW
  ) {
    return (
      <>
        <Nav
          hideProgressBar={true}
          back={isDynamicFunnelEnabled && isBackEnabled(PageName.PricingInterstitial)}
        />
        <MOCTierPricing />
      </>
    )
  }

  if (isFeatureEnabled(dynamicPricingScreen)) {
    return <DynamicPricingInterstitial />
  }

  return <DeprecatedPricingInterstitial />
}

export default enhance(PricingInterstitial)
